import { useTranslation } from 'react-i18next';
import type { StaticSharedField } from './types';
import type { intensityOrAbsoluteDropdownValue } from '/business/shared/components/pages/question/types';

import {
  ERR_TYPE_NUM_LARGE,
  ERR_TYPE_NUM_SMALL,
  ERR_TYPE_REQUIRED,
  FIELD_TYPE_NUMBER,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useAbsoluteEmissions({
  propName = 'absolute_emissions',
  dropdownPropName = 'absolute_emissions_unit',
  label = 'Absolute emissions:',
  subLabel,
  intensityOrAbsoluteDropdownValue,
  errMsg,
}: {
  propName?: string;
  dropdownPropName?: string;
  label?: string;
  subLabel?: string;
  intensityOrAbsoluteDropdownValue: intensityOrAbsoluteDropdownValue[];
  errMsg?: string;
}): StaticSharedField {
  const { t } = useTranslation();

  return {
    type: FIELD_TYPE_NUMBER,
    element: propName,
    inputMode: 'decimal',
    step: '.01',
    label: <span>{label}</span>,
    propName,
    subLabel: subLabel ? <span>{subLabel}</span> : null,
    // set to ' ', as we're using label as JSX, so if placeholder gets set to component it becomes object [object]
    placeholderI18nKey: ' ',
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOABSOLUTEORSUPPLIEREMISSIONS',
        errStr: errMsg || t('business:Errors.supplierForm.absoluteEmissions'),
      },
      {
        rule: ERR_TYPE_NUM_SMALL,
        errCode: 'ERRABSOLUTEORSUPPLIEREMISSIONSTOOLOW',
        errStr: errMsg || t('business:Errors.supplierForm.absoluteEmissions'),
        value: 0,
      },
      {
        rule: ERR_TYPE_NUM_LARGE,
        errCode: 'ERRABSOLUTEORSUPPLIEREMISSIONSTOOHIGH',
        errStr: errMsg || t('business:Errors.supplierForm.absoluteEmissions'),
        value: 999999,
      },
    ],
    dropdown: {
      propName: dropdownPropName,
      values: [
        ...intensityOrAbsoluteDropdownValue.map((value) => ({
          name: value.name,
          displayName: value.displayName,
        })),
      ],
    },
  };
}
